/**
 * WhatsApp de Carpepel: el canal donde se cotiza y coordina el envío de los
 * pedidos que se pagan "solo papel". Un solo lugar para el número, para que
 * no vuelva a haber copias desincronizadas regadas por los componentes.
 */
export const WHATSAPP_NUMBER = '525584032954';
export const WHATSAPP_DISPLAY = '+52 55 8403 2954';

/** Enlace wa.me con un mensaje ya escrito (codificado, nunca concatenado crudo). */
export function whatsappUrl(text = '') {
    const base = `https://wa.me/${WHATSAPP_NUMBER}`;
    return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}

/**
 * Mensaje para coordinar el envío de un pedido ya pagado. El backend arma el
 * mismo enlace (whatsapp_order_url) y lo manda en el resumen del pedido; este
 * es el respaldo por si la respuesta no lo trae.
 */
export function orderWhatsappText(order) {
    const lines = (order?.items || []).map((it) =>
        `- ${it.quantity} x ${it.product_name}${it.selected_size ? ` (${it.selected_size})` : ''}`
    );
    const subtotal = Math.round(order?.subtotal || 0).toLocaleString('en-US');
    return (
        `Hola Carpepel, acabo de pagar el pedido ${order?.tracking_number || ''} en carpepel.com:\n` +
        lines.join('\n') +
        `\nPagado (solo papel): $${subtotal} MXN\n\n` +
        'Quiero coordinar el envío. Mi código postal es: '
    );
}

/** Solo acepta enlaces wa.me al número de Carpepel (lo que venga del API se valida). */
export function safeWhatsappUrl(url, fallbackOrder) {
    if (typeof url === 'string' && url.startsWith(`https://wa.me/${WHATSAPP_NUMBER}?text=`)) return url;
    return whatsappUrl(orderWhatsappText(fallbackOrder));
}
